import React, { useEffect, useState } from 'react';
import { Container } from '@components/atoms/Container';
import { RoundIcon, RoundIconVariants } from '@components/atoms/RoundIcon';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@components/atoms/Typography';
import { useTranslation } from 'react-i18next';
import { usePrivacyPolicy } from '@services/usePrivacyPolicy';
import { Space } from '@components/atoms/Space';
import styles from './PrivacyPolicy.module.css';
import { useNotifications } from '@hooks/useNotifications';

export const PrivacyPolicy: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { showDefaultNotification } = useNotifications();
    const translations = {
        title: t('privacy-policy.title'),
    };

    const { request: requestPrivacyPolicy, error, lastResponseTime } = usePrivacyPolicy();
    const [policy, setPolicy] = useState('');

    useEffect(() => {
        requestPrivacyPolicy().then((data) => {
            if (data) {
                setPolicy(data.value);
            }
        });
    }, []);

    useEffect(() => {
        if (lastResponseTime) {
            if (error) {
                showDefaultNotification({ type: 'error', message: error });
            }
        }
    }, [lastResponseTime]);

    return (
        <Container>
            <div className={styles.header}>
                <RoundIcon
                    classes={styles.roundIcon}
                    icon="fa-thin fa-arrow-left"
                    variant={RoundIconVariants.variant1}
                    onClick={() => navigate(-1)}
                />

                <Typography fontSize="24" fontWeight="800" classes={styles.title}>
                    {translations.title}
                </Typography>
            </div>

            <Space spaceBreakpoints={{ xs: { space: 15 } }} />
            <div className="d-flex position-relative flex-column gap-3">
                <>{policy && <div className={styles.policyText} dangerouslySetInnerHTML={{ __html: policy }} />}</>
            </div>
        </Container>
    );
};
